(function () {
  'use strict';

  const STORAGE_KEY = 'cb_selected_city';

  /**
   * Obtém a cidade selecionada do localStorage
   * @returns {string|null} A cidade em maiúsculas (RJ, SP) ou null
   */
  function getSelectedCity() {
    try {
      const city = localStorage.getItem(STORAGE_KEY);
      return city ? city.toUpperCase() : null;
    } catch (error) {
      console.warn('Erro ao ler cidade do localStorage:', error);
      return null;
    }
  }

  /**
   * Encontra o drawer aberto (quick-buy-drawer que está visível)
   * @returns {HTMLElement|null} O drawer aberto ou null
   */
  function findOpenDrawer() {
    const drawers = document.querySelectorAll('quick-buy-drawer');
    for (const drawer of drawers) {
      // Verifica se o drawer está aberto (não tem display: none e não tem aria-hidden="true")
      const style = window.getComputedStyle(drawer);
      const ariaHidden = drawer.getAttribute('aria-hidden');
      if (style.display !== 'none' && ariaHidden !== 'true') {
        return drawer;
      }
    }
    return null;
  }

  /**
   * Controla a exibição dos botões de compra baseado na cidade e metafields
   * @param {HTMLElement|null} context - Contexto onde procurar (drawer aberto ou null para global)
   */
  function controlBuyButtons(context = null) {
    const city = getSelectedCity();
    
    // Procura pelo wrapper dos botões de compra no contexto especificado
    const searchRoot = context || document;
    const buyButtonsWrappers = searchRoot.querySelectorAll('[data-city-add-btn-wrapper]');
    
    if (buyButtonsWrappers.length === 0) {
      return;
    }

    // Processa cada wrapper encontrado
    buyButtonsWrappers.forEach(buyButtonsWrapper => {
      // Tenta obter os metafields do elemento de dados (que é atualizado quando a variante muda)
      // Procura dentro do mesmo contexto do wrapper
      const wrapperContext = buyButtonsWrapper.closest('quick-buy-drawer') || buyButtonsWrapper.closest('product-rerender') || document;
      const dataElement = wrapperContext.querySelector('.quickbuy-region-warning-data');
      let outOfStockRJValue, outOfStockSPValue;
      
      if (dataElement) {
        outOfStockRJValue = dataElement.getAttribute('data-out-of-stock-rj');
        outOfStockSPValue = dataElement.getAttribute('data-out-of-stock-sp');
      } else {
        // Fallback: usa os valores do wrapper
        outOfStockRJValue = buyButtonsWrapper.getAttribute('data-out-of-stock-rj');
        outOfStockSPValue = buyButtonsWrapper.getAttribute('data-out-of-stock-sp');
      }
      
      // Converte para boolean
      const outOfStockRJ = outOfStockRJValue === 'true';
      const outOfStockSP = outOfStockSPValue === 'true';

      // Verifica se deve esconder os botões
      let shouldHideButtons = false;

      // Se não há cidade selecionada, mostra os botões (o city-guard.js vai interceptar)
      if (!city) {
        buyButtonsWrapper.style.display = '';
        return;
      }

      // Verifica se a cidade atual está sem estoque
      if (city === 'RJ' && outOfStockRJ) {
        shouldHideButtons = true;
      } else if (city === 'SP' && outOfStockSP) {
        shouldHideButtons = true;
      }

      // Controla a exibição dos botões
      if (shouldHideButtons) {
        buyButtonsWrapper.style.display = 'none';
      } else {
        buyButtonsWrapper.style.display = '';
      }
    });
  }

  /**
   * Verifica e exibe o aviso de estoque baseado na cidade selecionada
   * @param {HTMLElement|null} context - Contexto onde procurar (drawer aberto ou null para todos)
   */
  function checkAndShowRegionWarning(context = null) {
    const city = getSelectedCity();

    // Se um contexto foi fornecido, procura apenas nele
    // Caso contrário, procura em todos os drawers E no DOM global (para product-info)
    let searchRoots = [];
    
    if (context) {
      searchRoots = [context];
    } else {
      // Procura em todos os drawers
      const drawers = document.querySelectorAll('quick-buy-drawer');
      searchRoots = Array.from(drawers);
      // Também adiciona o document para procurar na página de produto
      searchRoots.push(document);
    }

    Array.from(searchRoots).forEach(searchRoot => {
      // Procura pelos elementos dentro do contexto
      const dataElement = searchRoot.querySelector('.quickbuy-region-warning-data');
      const containerElement = searchRoot.querySelector('.quickbuy-region-warning-container');
      const messageElement = searchRoot.querySelector('.quickbuy-region-warning-message');
      const debugRJValue = searchRoot.querySelector('.quickbuy-region-warning-debug__rj-value');
      const debugSPValue = searchRoot.querySelector('.quickbuy-region-warning-debug__sp-value');

      // Se o container não existir, pula para o próximo
      if (!containerElement || !messageElement) {
        return;
      }

      // Obtém os valores dos metafields (valores brutos para debug)
      // Tenta primeiro do elemento de dados, depois do wrapper como fallback
      let outOfStockRJValue, outOfStockSPValue;
      
      if (dataElement) {
        outOfStockRJValue = dataElement.getAttribute('data-out-of-stock-rj');
        outOfStockSPValue = dataElement.getAttribute('data-out-of-stock-sp');
      } else {
        // Fallback: tenta obter do wrapper
        const buyButtonsWrapper = searchRoot.querySelector('[data-city-add-btn-wrapper]');
        if (buyButtonsWrapper) {
          outOfStockRJValue = buyButtonsWrapper.getAttribute('data-out-of-stock-rj');
          outOfStockSPValue = buyButtonsWrapper.getAttribute('data-out-of-stock-sp');
        }
      }
      
      // Converte para boolean
      const outOfStockRJ = outOfStockRJValue === 'true';
      const outOfStockSP = outOfStockSPValue === 'true';

      // Preenche os valores de debug sempre
      if (debugRJValue) {
        debugRJValue.textContent = outOfStockRJValue !== null ? outOfStockRJValue : 'null';
      }
      if (debugSPValue) {
        debugSPValue.textContent = outOfStockSPValue !== null ? outOfStockSPValue : 'null';
      }

      // Verifica se a cidade atual está sem estoque
      let isOutOfStock = false;

      if (city === 'RJ' && outOfStockRJ) {
        isOutOfStock = true;
      } else if (city === 'SP' && outOfStockSP) {
        isOutOfStock = true;
      }

      // Controla a exibição da mensagem de aviso
      if (isOutOfStock) {
        messageElement.style.display = 'block';
        // Exibe o container e aplica margin-top apenas quando há warning
        containerElement.style.display = 'block';
        containerElement.style.marginTop = '10px';
      } else {
        messageElement.style.display = 'none';
        // Oculta o container quando não há warning para evitar espaçamento indevido
        containerElement.style.display = 'none';
        containerElement.style.marginTop = '0';
      }
    });
  }

  /**
   * Função principal que executa todas as verificações
   * @param {HTMLElement|null} context - Contexto onde procurar (drawer aberto ou null para todos)
   */
  function runAllChecks(context = null) {
    checkAndShowRegionWarning(context);
    controlBuyButtons(context);
  }

  /**
   * Verifica se estamos na página de produto
   * @returns {boolean}
   */
  function isProductPage() {
    return document.querySelector('.product-info') !== null ||
           document.querySelector('.shopify-section--main-product') !== null ||
           window.location.pathname.includes('/products/');
  }

  /**
   * Inicializa o sistema de avisos
   */
  function init() {
    // Se estamos na página de produto, adiciona um delay para garantir que o DOM está pronto
    // O script pode ser carregado com defer e executar antes dos elementos estarem disponíveis
    const initDelay = isProductPage() ? 300 : 0;
    
    setTimeout(function() {
      // Verifica imediatamente
      runAllChecks();
      
      // Se estamos na página de produto, adiciona um observer para detectar mudanças nos metafields
      if (isProductPage()) {
        const dataElements = document.querySelectorAll('.quickbuy-region-warning-data');
        dataElements.forEach(function(dataElement) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && 
                  (mutation.attributeName === 'data-out-of-stock-rj' || 
                   mutation.attributeName === 'data-out-of-stock-sp')) {
                // Quando os metafields mudam, executa as verificações
                setTimeout(function() {
                  runAllChecks();
                }, 50);
              }
            });
          });
          
          observer.observe(dataElement, {
            attributes: true,
            attributeFilter: ['data-out-of-stock-rj', 'data-out-of-stock-sp']
          });
        });
      }
    }, initDelay);

    // Observa mudanças quando o produto é re-renderizado (mudança de variante)
    document.addEventListener('product:rerendered', function (event) {
      // Pequeno delay para garantir que o DOM foi atualizado
      setTimeout(function() {
        // Tenta encontrar o contexto do evento (o elemento que foi re-renderizado)
        let context = null;
        if (event && event.target) {
          context = event.target.closest('quick-buy-drawer');
        }
        // Se não encontrou no evento, tenta encontrar o drawer aberto
        if (!context) {
          context = findOpenDrawer();
        }
        // Se não há drawer aberto, usa null para procurar em todos os lugares (incluindo product-info)
        // Isso é importante para a página de produto onde não há drawer
        if (!context) {
          context = null;
        }
        runAllChecks(context);
      }, 150);
    });

    // Observa quando o quick buy drawer é aberto
    document.addEventListener('quickbuy:open', function () {
      // Usa múltiplos delays para garantir que o conteúdo foi carregado via fetch
      // O drawer pode carregar o conteúdo de forma assíncrona
      [100, 300, 500].forEach(function(delay) {
        setTimeout(function() {
          const openDrawer = findOpenDrawer();
          if (openDrawer) {
            // Verifica se os elementos já existem no drawer
            const hasWarningData = openDrawer.querySelector('.quickbuy-region-warning-data');
            const hasWarningContainer = openDrawer.querySelector('.quickbuy-region-warning-container');
            
            // Se os elementos existem, executa as verificações
            if (hasWarningData || hasWarningContainer) {
              runAllChecks(openDrawer);
            }
          }
        }, delay);
      });
    });

    // Observa mudanças no localStorage (caso a cidade seja alterada em outra aba)
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        runAllChecks(); // null = procura em todos os lugares
      }
    });

    // Observa mudanças na cidade (quando o usuário seleciona uma cidade)
    // Usa um intervalo para verificar mudanças no localStorage
    let lastCity = getSelectedCity();
    setInterval(function() {
      const currentCity = getSelectedCity();
      if (currentCity !== lastCity) {
        lastCity = currentCity;
        runAllChecks(); // null = procura em todos os lugares
      }
    }, 500);
    
    // Observa o evento customizado quando a cidade é alterada
    window.addEventListener('city:changed', function () {
      runAllChecks(); // null = procura em todos os lugares
    });
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
